import PlusCircle from '@assets/icons/plus-circle.svg'
import { Icon } from './Icon'

export const PlusCircleIcon = Icon(PlusCircle)
